import { DateCell } from "@/components/shared/cells/date-cell";

type Props = {
  createdAt: string | Date;
  format?: string;
};

export const CreatedAtCell = ({
  createdAt,
  format = "dd.MM.yy HH:mm",
}: Props) => {
  return <DateCell value={new Date(createdAt)} format={format} />;
};
